<template lang="pug">
.alert.alert-tasks.mt-20
  .alert-head
    img.label-logo(
      :src="IMAGE_HS_TASKS_LOGO"
      width="125"
    )
    a.ajax-dialog.alert-link.tasks-learn-more.tasks-learn-more-button(
      :href="`/learn_more/tasks/${organizationId}.dialog?w=1`"
      data-source="unlinked_project-create"
    )
      | Learn more
  .alert-text An agile project management tool with sprints and visual workflows.
</template>

<script>
import { IMAGE_HS_TASKS_LOGO } from '~/rails_assets';

export default {
  name: 'AppTasksAlert',
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      IMAGE_HS_TASKS_LOGO,
    };
  },
};
</script>
